import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMediumComponent } from './simple-icons-medium.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMediumComponent ],
    exports:      [ SimpleIconsMediumComponent ],
    bootstrap:    []
})
export class SimpleIconsMediumModule {}
